import { useTranslation } from 'react-i18next';

export const useAdminConversationCreateCategory = () => {
    const { t } = useTranslation();
    return { t };
};
